import { Static, Type } from '@sinclair/typebox'

export const AdminFlow = Type.Object({
    id: Type.String(),
    name: Type.Union([Type.String(), Type.Null()]),
    status: Type.String(),
    externalId: Type.Union([Type.String(), Type.Null()]),
    externalCustomerId: Type.Union([Type.String(), Type.Null()]),
    tenantId: Type.String(),
    pieceNames: Type.Array(Type.String()),
    created: Type.String(),
    updated: Type.String(),
})

export type AdminFlow = Static<typeof AdminFlow>

export const ListAdminFlowsRequest = Type.Object({
    cursor: Type.Optional(Type.String()),
    limit: Type.Optional(Type.Number({ default: 20 })),
    search: Type.Optional(Type.String()),
    status: Type.Optional(Type.Array(Type.String())),
    externalId: Type.Optional(Type.String()),
    externalCustomerId: Type.Optional(Type.String()),
    tenantId: Type.Optional(Type.String()),
    userId: Type.Optional(Type.String()),
})

export type ListAdminFlowsRequest = Static<typeof ListAdminFlowsRequest>
